export default "__VITE_ASSET__9584f3da__"